/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import { namespace } from 'vuex-class';
import { Vue, Component, Prop } from 'vue-property-decorator';
import type { PreQueryChannleProduct } from '@/model/preApplyResult';
import { openThirdPage } from '@/api/native/utils';
import platform from '@/shared/utils/platform';
import { ApplyOrderStatus, BannerDataType } from '../../types';

const style = require('./index.module.scss');

const PreApplyResultStore = namespace('preApplyResult');
@Component
export default class ApplyProcess extends Vue {
  @Prop(String) readonly outOrder!: boolean;

  @PreApplyResultStore.State bannerData!: BannerDataType | null;

  @PreApplyResultStore.State applyData!: PreQueryChannleProduct.Infomation;

  private get channelList(): PreQueryChannleProduct.CreditResultInfoVOS[] {
    return (this.applyData.creditResultInfoVOS || []).reverse();
  }

  /** 获取顶部noticebar 文案，因屯单需求改造 */
  private get remindMessage(): string {
    return (this.applyData && this.applyData.remind)
    || '申请评估需30秒～3分钟，请耐心等待';
  }

  private getStatusText(creditStatus: string) {
    return (
      {
        [ApplyOrderStatus.SUCCEEDED]: '',
        [ApplyOrderStatus.SUBMITTING]: '审核中',
        [ApplyOrderStatus.FAILED]: '审核未通过',
      }[creditStatus as ApplyOrderStatus] || ''
    );
  }

  private renderChannelItem(
    channelItem: PreQueryChannleProduct.CreditResultInfoVOS,
  ) {
    return (
      <div class={style.channelItem}>
        <span
          class={[
            style.statusIcon,
            style[`statusIcon_${channelItem.creditStatus}`],
          ]}
        />

        <div class={style.itemContent}>
          <span
            class={style.productIcon}
            style={{
              backgroundImage: `url(${channelItem.productIcon})`,
            }}
          />
          {channelItem.productName}
        </div>

        <span
          class={[
            style.statusName,
            style[`statusName_${channelItem.creditStatus}`],
          ]}
        >
          {this.getStatusText(channelItem.creditStatus)}
        </span>
      </div>
    );
  }

  /** 新版样式 */
  private renderNewChannelItem(
    channelItem: PreQueryChannleProduct.CreditResultInfoVOS,
  ) {
    return (
      <div class={style.channelItem}>
        <div class={style.itemContent}>
          <span
            class={style.productIcon}
            style={{
              backgroundImage: `url(${channelItem.productIcon})`,
            }}
          />
          {channelItem.productName}
        </div>
        {channelItem.creditStatus === ApplyOrderStatus.FAILED && (
          <span
            class={[
              style.statusIcon,
              style[`statusIcon_${ApplyOrderStatus.FAILED}`],
            ]}
          />
        )}
        <span
          class={[
            style.statusName,
            style[`statusName_${channelItem.creditStatus}`],
          ]}
        >
          {this.getStatusText(channelItem.creditStatus)}
        </span>
      </div>
    );
  }

  // 支付宝小程序环境, 外采环境 不展示风险评估报告
  private get isShowrReport(): boolean {
    const showBanner = Object.keys(this.bannerData || {}).length > 0;
    return showBanner && !(platform.isAlipayMini || platform.isDingTalk || this.outOrder);
  }


  private render() {
    return (
      <div class={style.processContainer}>
        <div class={style.processTopContent}>
          <div class={[style.processIcon, this.outOrder ? style.outerTop : '']}></div>
          {this.outOrder ? (
            <div class={style.outOrder}>
              <p class={style.title}>提交成功，正在审核中</p>
              <p class={style.subTitle}>预计等待时间：30秒～3分钟</p>
            </div>
          ) : (
            <p class={style.processText}>{this.remindMessage}</p>
          )}
        </div>

        <div class={style.channelList}>
          {this.channelList.map(this.renderNewChannelItem.bind(this))}
        </div>

        {this.isShowrReport && (
          <div class={style.bannerContainer}>
            <div
              class={style.banner}
              style={{
                backgroundImage: `url(${this.bannerData ? this.bannerData.imageUrl : ''})`,
              }}
              onClick={this.openBannerUrl.bind(this)}
            />
          </div>
        )}
      </div>
    );
  }

  private openBannerUrl() {
    if (this.bannerData) {
      this.$ubtPageButton(
        'finance_PreApplyResultBannerClick',
        'BannerName',
        this.bannerData.name,
      );

      openThirdPage(this.bannerData.url);
    }
  }
}
